export class FileGroupCustomerEntity {

    id: number
    groupId: number;
    customerId: number;

constructor (){}
}
